// extracted by mini-css-extract-plugin
export default {"root":"DisabledImageOverlay_root__HKKpd","content":"DisabledImageOverlay_content__HpBZy"};